import { ErrorUtil } from '@/modules/common/utils/error.util.ts';
import { notification } from '@/modules/common/composables/use-notification.ts';

export function reportEditError(key: string, error: unknown) {
  if (ErrorUtil.isBusinessError(error) || ErrorUtil.isUnexpected(error)) {
    notification.error(key, error);
  }
}

export async function attemptEditStep(key: string, action: () => Promise<unknown>) {
  try {
    await action();
    return true;
  } catch (error) {
    reportEditError(key, error);
    return false;
  }
}
